import { Dialog, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import { ReactNode } from "react";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import UiTypography from "./UiTypography";

type UiCenterModalProps = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  width?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export default function UiCenterModal({
  open,
  onClose,
  title,
  width = "min(980px, calc(100vw - 32px))",
  children,
  footer,
}: UiCenterModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width,
          borderRadius: "16px",
          m: "16px",
          boxShadow: "0px 12px 32px rgba(15, 23, 42, 0.18)",
        },
      }}
    >
      <MDBox display="flex" flexDirection="column" sx={{ maxHeight: "90vh" }}>
        <MDBox
          px="24px"
          py="18px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderBottom={`1px solid ${draftColors.border}`}
          sx={{ flexShrink: 0 }}
        >
          <UiTypography uiVariant="heading-lg">{title}</UiTypography>
          <IconButton onClick={onClose} sx={{ border: `1px solid ${draftColors.border}` }}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>

        <MDBox
          p="18px"
          display="flex"
          flexDirection="column"
          gap="14px"
          sx={{ overflowY: "auto", flex: 1 }}
        >
          {children}
        </MDBox>

        {footer && (
          <MDBox
            px="24px"
            py="16px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderTop={`1px solid ${draftColors.border}`}
            sx={{ flexShrink: 0 }}
          >
            {footer}
          </MDBox>
        )}
      </MDBox>
    </Dialog>
  );
}
